module.exports = __webpack_public_path__ + "static/img/image005.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image005.gif
// module id = PElG
// module chunks = 1